var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-button",class:[
    _vm.width,
    _vm.xPadding,
    _vm.yPadding,
    _vm.borderRadius,
    _vm.fontSize,
    _vm.color,
    _vm.border,
    _vm.shadow,
    _vm.borderColor,
    _vm.disabled ? 'cursor-not-allowed bg-gray-dark' : _vm.backgroundColor,
    _vm.hover,
    _vm.cursor,
    _vm.justify ],attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":function($event){$event.stopPropagation();return _vm.action($event)}}},[(!_vm.loading)?_vm._t("icon"):_vm._e(),_c('div',{staticClass:"flex items-center"},[(_vm.loading)?_c('Spinner',{staticClass:"mr-3"}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }